<!--  HTML -->
<template>
<!-- アンケート回答の処理 -->
<div id="page1">
  <div v-if="completed === false">
    <p v-if="end === false" class="question_top">
      ・後継者の育成も考えると、事業承継の準備には5年～10年ほどかかると言われていますので、60歳頃には準備に着手したいところです。<br>
      ・会社の大きな転機となる事業承継は、早めの準備、計画的な取り組みが肝要です。 <br>
      ・自社の現状や今後の方向性を確認するために、「事業承継自己診断」をお勧めします。
    </p>
    <img src="../assets/jigyoshokei_head.png" class="q_top_img">
    <div v-if="end === false" id="questionnaire">
      <!-- 問題遷移 -->
      <div v-if="end === false" class="question_area">
        <div class="question_content">
          <h2 id="number">{{q_number}}</h2>
          <p id="statement" v-html="q_statement"/>
        </div>
        <!-- 回答ボタン -->
        <a><button id="yes" v-on:click="change(1)">はい</button></a>
        <a><button id="no" v-on:click="change(2)">いいえ</button></a>
      </div>
    </div>

  <div v-if="end === false" class="pdf_contents">
    <p>
      PDF版もご用意しております。ダウンロードしてご使用ください。<br>
      相談をご希望の場合「事業承継診断ヒアリングチェックシート」をセンターまで送付ください。<br>
      お問い合せ先等の情報はページの下記の「お問い合わせ先」をご確認ください。
    </p>
      <a class="dl_btn" target=”_blank” href="https://www.tonio.or.jp/cms/wp-content/uploads/jigyoshokei_check.pdf">
      <img src="../assets/btn_pdf-dl.png" alt="PDF版ダウンロード">
      </a>
  </div>

    <!-- 回答終了後の処理 -->
    <div v-if="end === true">

      <div id=result>
        <h2 id="result_title">診断結果</h2>
        <div class="result_contents_wrapper">
          <div class="result_contents">
            <p class="result_statement" v-html="q_result"/>
          </div>
        </div>
      </div>
      <div id="history">
        <h2 id="history_title">回答結果</h2>
        <div class="history_contents">
          <div v-for="item in item" v-bind:key="item.q" class="history_content">
            <div id="history_statement">
              <p v-html="item.number + ' ' + item.statement"/>
            </div>
            <p id="history_answer">
              {{ item.answer }}
            </p>
          </div>
        </div>
      </div>
      <Input :qitems="item" :qresult="q_result" :qresultmail="q_result_mail"/>
    </div>
  </div>
  <div v-if="completed === true">
    <div id=completed>
      <h2 id="completed_title">メール送信完了</h2>
      <div class="completed_contents">
        <p class="completed_statement">
          お申し込みいただき、誠にありがとうございます。
          ご入力いただいた情報は無事に送信されました。<br>
          この後、自動確認メールが送信されます。
          「自動送信メール」が届かない場合、何らかのメール送信トラブルが考えられます。
          お手数ですが、もう一度、同じ手順でメールを送信されるか、下記のお問い合わせ先までご連絡ください。
          <span><img src="../assets/jigyoshokei_foot.png"></span>
        </p>
      </div>
    </div>
  </div>
</div>
</template>

<!-- Javascript -->

<script>
import Input from './Inputform.vue'

export default {
  name: 'Page1',
  components: {
    Input
  },
  props: {
    items: Array
  },
  data() {
    return {
      //問題番号・問題文
      q_statement: this.items[1].Q,
      q_number: this.items[11].Q,

      a_number: 1, //回答する問題番号
      e_number: 0, //回答終了時の問題
      q_flug: 0, //分岐条件
      q_flug_8_9: 0, // 設問８と９の分岐
      end: false, //回答終了したかどうか
      q_result: '', //診断結果の文章
      q_result_mail: '', //メール用診断結果の文章
      q_answer: '', //yes or no
      item: [{ //回答した問題の内容を保存
        number: '',
        statement: '',
        answer: ''
      }, ],
      completed: false
    }
  },
  methods: {
    change: function(q) {
      if ((this.a_number > 2 && this.a_number < 10) && q === 2) {
        this.q_flug++;
      }
      if ((this.a_number === 8 || this.a_number === 9) && q === 2) {
        this.q_flug_8_9++;
      }
      if(this.a_number === 9){
        this.q_flug++;
      }

      if (q === 1) {
        this.q_answer = 'はい'
      } else {
        this.q_answer = 'いいえ'
      }

      if (this.a_number === 1) {
        this.item.push({
          number: this.items[this.a_number + 10].Q,
          statement: this.items[this.a_number].Q,
          answer: this.q_answer
        })

        if (q === 1) {
          this.a_number = 2;
        } else {
          this.a_number = 7;
        }
      } else if (this.a_number === 2) {
        this.item.push({
          number: this.items[this.a_number + 10].Q,
          statement: this.items[this.a_number].Q,
          answer: this.q_answer
        })

        if (q === 1) {
          this.a_number = 3;
        } else {
          this.a_number = 8;
        }
      } else if (this.a_number === 7) {
        this.item.push({
          number: this.items[this.a_number + 10].Q,
          statement: this.items[this.a_number].Q,
          answer: this.q_answer
        })
        if (q === 1) {
          this.a_number = 8;
        } else {
          this.e_number = this.a_number;
          this.a_number = 10;
        }
      } else if (this.a_number === 6 || this.a_number === 9) {
        this.item.push({
          number: this.items[this.a_number + 10].Q,
          statement: this.items[this.a_number].Q,
          answer: this.q_answer
        })
        this.e_number = this.a_number;
        this.a_number = 10
      } else {
        this.item.push({
          number: this.items[this.a_number + 10].Q,
          statement: this.items[this.a_number].Q,
          answer: this.q_answer
        })
        this.a_number++;
      }
      if (this.a_number === 2) {
        this.q_number = this.items[this.a_number + 10].Q;
        this.q_statement = this.items[this.a_number].Q;
      } else if (this.a_number === 3) {
        this.q_number = this.items[this.a_number + 10].Q;
        this.q_statement = this.items[this.a_number].Q;
      } else if (this.a_number === 4) {
        this.q_number = this.items[this.a_number + 10].Q;
        this.q_statement = this.items[this.a_number].Q;
      } else if (this.a_number === 5) {
        this.q_number = this.items[this.a_number + 10].Q;
        this.q_statement = this.items[this.a_number].Q;
      } else if (this.a_number === 6) {
        this.q_number = this.items[this.a_number + 10].Q;
        this.q_statement = this.items[this.a_number].Q;
      } else if (this.a_number === 7) {
        this.q_number = this.items[this.a_number + 10].Q;
        this.q_statement = this.items[this.a_number].Q;
      } else if (this.a_number === 8) {
        this.q_number = this.items[this.a_number + 10].Q;
        this.q_statement = this.items[this.a_number].Q;
      } else if (this.a_number === 9) {
        this.q_number = this.items[this.a_number + 10].Q;
        this.q_statement = this.items[this.a_number].Q;
      } else if (this.a_number === 10) {
        this.end = true;
      } else {
        this.q_statement = "エラーが起きました";
      }
      if (this.end === true) {
        if (this.q_flug === 0) {
          this.q_result = '準備は万全ですね！今後お困りの場合は支援機関にご相談下さい。';
          this.q_result_mail = '準備は万全ですね！今後お困りの場合は支援機関にご相談下さい。';
        } else if (this.e_number === 6) {
          this.q_result = '円滑に事業承継を進めていくため、事業承継計画の策定等による計画的な取り組みが求められます。ご相談は、<a href="#title">下記フォーム</a>に必要事項を入力し送信ください。（センターからご連絡のうえ、適切な対応策をご提案いたします。）'
          this.q_result_mail = '円滑に事業承継を進めていくため、事業承継計画の策定等による計画的な取り組みが求められます。'
        } else if (this.e_number === 7) {
          this.q_result = '第三者への事業引継ぎという手段もあります。<br>詳しくは、<a href="#title">下記フォーム</a>に必要事項を入力し送信ください。（センターからご連絡のうえ、適切な対応策をご提案いたします。）'
          this.q_result_mail = '第三者への事業引継ぎという手段もあります。'
        } else if (this.e_number === 9) {
          if (this.q_flug_8_9 > 0) {
            this.q_result = '企業の存続に向け、具体的に事業承継についての課題の整理や方向性の検討を行う必要があります。ご相談は、<a href="#title">下記フォーム</a>に必要事項を入力し送信ください。（センターからご連絡のうえ、適切な対応策をご提案いたします。）'
            this.q_result_mail = '企業の存続に向け、具体的に事業承継についての課題の整理や方向性の検討を行う必要があります。'
          } else {
            this.q_result = '後継者候補へ承継の打診を行う際には、最適な時期や方法を検討する必要があります。ご相談は、<a href="#title">下記フォーム</a>に必要事項を入力し送信ください。（センターからご連絡のうえ、適切な対応策をご提案いたします。）';
            this.q_result_mail = '後継者候補へ承継の打診を行う際には、最適な時期や方法を検討する必要があります。';
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- CSS -->
<style lang="scss">
#page1 {
  // フォントサイズ

  max-width: 1060px;

  .q_top_img {
    max-width: 760px;
    width: 100%;
    vertical-align: bottom;
  }

  .question_top {
    width: 100%;
    display: inline-block;
    text-align: left;
    margin-bottom: 30px;
  }

  #questionnaire {

    width: 100%;
    background-color: #FCF9E8;
    display: inline-block;

    h2 {
      font-weight: bold;
      font-size: 30px;
      line-height: 30px;
    }

    p {
      font-weight: bold;
      font-size: 24px;
      line-height: 34px;
    }

    .question_area {
      margin-top: 88px;

      .question_content {
        position: relative;
        margin-right: 40px;
        margin-left: 40px;
        margin-bottom: 40px;
        background-color: #fff;
        border: 1px solid #F8A600;

        h2 {
          position: absolute;
          top: -48px;
          right: 0;
          left: 0;
          margin: auto;
          color: #fff;
          background-color: #EA5759;
          width: 96px;
          padding: 33px 0;
          border-radius: 50%;
        }

        p {
          // opacity: 0.75;
          padding:  78px 40px 40px 40px;

          .sp_br {
            display: inline;
          }
        }
      }
    }


    #yes, #no {
      font-weight: bold;
      font-size: 20px;
      line-height: 20px;
      color: #fff;
      border: none;
      width: 240px;
      height: 60px;
      margin: 0 10px 40px 10px;
    }

    #yes:hover, #no:hover {
      opacity: 0.7;
    }

    #yes {
      background-color: #37A800;
    }

    #no {
      background-color: #FF9900;
    }
  }

  .pdf_contents {

    margin-top: 30px;

    p {
      margin-bottom: 20px;
    }

    .dl_btn{
      display: inline-block;
      &:hover{
        opacity: 0.7;
      }

      img {
        @media screen and (min-width:768px) {
          width: 320px;
        }
        @media screen and (max-width:767px) {
          width: 100%;
        }
      }
    }
  }

  #result, #history {
    h2 {
      font-weight: bold;
      font-size: 30px;
      line-height: 48px;
      padding: 40px 0;
    }
  }

  #result {

    a, a:link, a:visited, a:active {
        color: #000000;
    }

    background-color: #FFD6D7;
    margin-bottom: 40px;

    h2 {
      color: #BF1717;
    }

    p {
      font-weight: bold;
      font-size: 24px;
      line-height: 36px;
    }

    .result_contents_wrapper {
      margin-right: 40px;
      margin-left: 40px;
      padding-bottom: 40px;

      .result_contents {
        text-align: left;
        background-color: #fff;
        padding: 40px;
        border: 1px solid #BF1717;

        .sp_br {
          display: inline;
        }
      }
    }
  }

  #history {
    background-color: #FCF9E8;
    padding-bottom: 10px;
    h2 {
      color: #FF9900;
    }

    p {
      font-weight: bold;
      font-size: 21px;
      line-height: 30px;
    }

    #history_statement {
      background-color: #fff;
      border: 1px solid #F8A600;
      padding: 20px;
      margin-right: 40px;
      margin-left: 40px;
      text-align: left;

      p {
        display: inline-block;
        vertical-align: top;
      }

      .sp_br {
        display: none;
      }
    }

    #history_answer {
      text-align: left;
      padding: 10px 0 30px 60px;
    }

    .history_content:first-child {
      display: none;
    }
  }

  #completed {
    background-color: #CEF3BC;

    h2 {
      font-weight: bold;
      font-size: 30px;
      line-height: 42px;
      color: #37A800;
      margin: 40px 0;
      display: inline-block;
      @media all and (max-width: 767px) {
        font-weight: bold;
        font-size: 24px;
        line-height: 36px;
      }
    }

    p {
      font-size: 16px;
    }

    .completed_contents {
      margin: 0 40px 40px 40px;
      display: inline-block;

      .completed_statement {
        border: 1px solid #0C6F00;
        background-color: #fff;
        padding: 40px;
        text-align: left;

        span {
          text-align: center;
          display: block;

          img {
            margin-top: 40px;
            max-width: 100%
          }
        }
      }
    }
  }
}

// 以下、SP（スマホ以下）
@media all and (max-width: 767px) {
  #page1 {
    width: 100%;

    #questionnaire {

      h2 {
        font-weight: bold;
        font-size: 24px;
        line-height: 45px;
      }

      p {
        font-weight: bold;
        font-size: 20px;
        line-height: 32px;
      }

      .question_area {
        margin-top: 58px;

        .question_content {
          margin-right: 20px;
          margin-left: 20px;
          margin-bottom: 20px;

          h2 {
            top: -38px;
            width: 76px;
            padding: 15px 0 16px 0;
          }

          p {
            padding:  58px 20px 19px 20px;
            .sp_br {
              display: none;
            }
          }
        }
      }

      #yes, #no {
        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
        width: 152px;
        height: 44px;
        margin: 0 5px 20px 5px;
      }
    }

    .pdf_contents {
      p {
        text-align: left;
      }

      // .dl_btn {
      //   width: 100%;
      // }
    }

    #result, #history {
      h2 {
        font-weight: bold;
        font-size: 24px;
        line-height: 34px;
        padding: 20px 0;
      }
    }

    #result {
      margin-bottom: 17px;

      p {
        font-weight: bold;
        font-size: 18px;
        line-height: 29px;
      }

      .result_contents_wrapper {
        margin-right: 20px;
        margin-left: 20px;
        padding-bottom: 20px;

        .result_contents {
          margin: 0 20px 20px 20px auto;
          padding: 20px;

          .sp_br {
            display: none;
          }
        }
      }
    }

    #history {
      padding-bottom: 5px;
      p {
        font-weight: bold;
        font-size: 15px;
        line-height: 24px;
      }

      #history_statement {
        padding: 10px;
        margin-right: 20px;
        margin-left: 20px;
      }

      #history_answer {
        padding: 10px 0 15px 30px;
      }
    }

    #completed {
      h2 {
        margin: 20px 0;
      }
      p {
        font-size: 15px;
      }

      .completed_contents {
        margin: 0 20px 20px 20px;

        .completed_statement {
          padding: 20px;

          img {
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
